import { FormComponent } from '@ubud/form';
import { Component } from '@angular/core';
import { RegisterUser } from '@lemsar/auth/domains/models/register';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    12/06/2018
 */
@Component({
    selector: 'lemsar-register-user-form',
    templateUrl: './register-user.form.html',
})
export class RegisterUserForm extends FormComponent<RegisterUser> {}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/components/register-user.form.ts